window.addEventListener('DOMContentLoaded', () => {
    var vid = document.getElementById('myVideo')

    function enableMute() {
        vid.muted = false
    }

    function myFunction1(imgs) {
        var expandImg1 = document.getElementById('expandedImg1')
        expandImg1.src = imgs.src
        expandImg1.parentElement.style.display = 'block'
    }

    function myFunction2(imgs) {
        var expandImg2 = document.getElementById('expandedImg2')
        expandImg2.src = imgs.src
        expandImg2.parentElement.style.display = 'block'
    }

    function myFunction3(imgs) {
        var expandImg3 = document.getElementById('expandedImg3')
        expandImg3.src = imgs.src
        expandImg3.parentElement.style.display = 'block'
    }

    function myFunction4(imgs) {
        var expandImg4 = document.getElementById('expandedImg4')
        expandImg4.src = imgs.src
        expandImg4.parentElement.style.display = 'block'
    }

    function myFunction5(imgs) {
        var expandImg5 = document.getElementById('expandedImg5')
        expandImg5.src = imgs.src
        expandImg5.parentElement.style.display = 'block'
    }

    function myFunction6(imgs) {
        var expandImg6 = document.getElementById('expandedImg6')
        expandImg6.src = imgs.src
        expandImg6.parentElement.style.display = 'block'
    }
})